export const tutorialQuestions = {
  turn1: [
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q4.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q4.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q4.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q4.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q5.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q5.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q5.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q5.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q6.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q6.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q6.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q6.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q1.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q1.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q1.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q1.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q2.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q2.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q2.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q2.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q3.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q3.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q3.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q3.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn1.questions.q7.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn1.questions.q7.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn1.questions.q7.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn1.questions.q7.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
  ],
  turn2: [
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q1.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q1.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q1.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q1.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q2.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q2.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q2.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q2.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q3.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q3.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q3.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q3.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q4.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q4.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q4.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q4.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q5.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q5.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q5.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q5.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn2.questions.q6.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn2.questions.q6.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn2.questions.q6.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn2.questions.q6.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
  ],
  turn3: [
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn3.questions.q1.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn3.questions.q1.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn3.questions.q1.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn3.questions.q1.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn3.questions.q2.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn3.questions.q2.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn3.questions.q2.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn3.questions.q2.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn3.questions.q3.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn3.questions.q3.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn3.questions.q3.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn3.questions.q3.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn3.questions.q4.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn3.questions.q4.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn3.questions.q4.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn3.questions.q4.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn3.questions.q5.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn3.questions.q5.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn3.questions.q5.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn3.questions.q5.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
  ],
  turn4: [
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn4.questions.q1.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn4.questions.q1.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn4.questions.q1.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn4.questions.q1.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn4.questions.q2.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn4.questions.q2.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn4.questions.q2.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn4.questions.q2.answer3',
          isCorrect: true,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn4.questions.q3.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn4.questions.q3.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn4.questions.q3.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn4.questions.q3.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn4.questions.q4.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn4.questions.q4.answer1',
          isCorrect: true,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn4.questions.q4.answer2',
          isCorrect: false,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn4.questions.q4.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
    {
      status: 'CERTIFIED',
      likes: 1,
      deleted: false,
      question: 'tutorial.turn4.questions.q5.question',
      choices: [
        {
          _id: '5c8f49ef35407b000f6dfd9a',
          text: 'tutorial.turn4.questions.q5.answer1',
          isCorrect: false,
          key: 1,
        },
        {
          _id: '5c8f49ef35407b000f6dfd99',
          text: 'tutorial.turn4.questions.q5.answer2',
          isCorrect: true,
          key: 2,
        },
        {
          _id: '5c8f49ef35407b000f6dfd98',
          text: 'tutorial.turn4.questions.q5.answer3',
          isCorrect: false,
          key: 3,
        },
      ],
    },
  ],
}

export const questions = {
  '5c3eefbcfaff8ad688b1c1e9': {
    _id: '5c3eefbcfaff8ad688b1c1e9',
    status: 'CERTIFIED',
    deleted: false,
    question: 'questions.certifiedQuestions.question01.text',
    choices: [
      {
        text: 'questions.certifiedQuestions.question01.answer1',
        key: 1,
        isCorrect: true,
      },
      {
        text: 'questions.certifiedQuestions.question01.answer2',
        key: 2,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question01.answer3',
        key: 3,
        isCorrect: false,
      },
    ],
  },
  '5c3eefbcfaff8ad688b1c1ee': {
    _id: '5c3eefbcfaff8ad688b1c1ee',
    status: 'CERTIFIED',
    deleted: false,
    question: 'questions.certifiedQuestions.question02.text',
    choices: [
      {
        text: 'questions.certifiedQuestions.question02.answer1',
        key: 1,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question02.answer2',
        key: 2,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question02.answer3',
        key: 3,
        isCorrect: true,
      },
    ],
  },
  '5c3eefbcfaff8ad688b1c1f3': {
    _id: '5c3eefbcfaff8ad688b1c1f3',
    status: 'CERTIFIED',
    deleted: false,
    question: 'questions.certifiedQuestions.question03.text',
    choices: [
      {
        text: 'questions.certifiedQuestions.question03.answer1',
        key: 1,
        isCorrect: true,
      },
      {
        text: 'questions.certifiedQuestions.question03.answer2',
        key: 2,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question03.answer3',
        key: 3,
        isCorrect: false,
      },
    ],
  },
  '5c3eefbcfaff8ad688b1c1f8': {
    _id: '5c3eefbcfaff8ad688b1c1f8',
    status: 'CERTIFIED',
    deleted: false,
    question: 'questions.certifiedQuestions.question04.text',
    choices: [
      {
        text: 'questions.certifiedQuestions.question04.answer1',
        key: 1,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question04.answer2',
        key: 2,
        isCorrect: true,
      },
      {
        text: 'questions.certifiedQuestions.question04.answer3',
        key: 3,
        isCorrect: false,
      },
    ],
  },
  '5c3eefbdfaff8ad688b1c1fb': {
    _id: '5c3eefbdfaff8ad688b1c1fb',
    status: 'CERTIFIED',
    deleted: false,
    question: 'questions.certifiedQuestions.question05.text',
    choices: [
      {
        text: 'questions.certifiedQuestions.question05.answer1',
        key: 1,
        isCorrect: true,
      },
      {
        text: 'questions.certifiedQuestions.question05.answer2',
        key: 2,
        isCorrect: false,
      },
      {
        text: 'questions.certifiedQuestions.question05.answer3',
        key: 3,
        isCorrect: false,
      },
    ],
  },
}
